export default __webpack_public_path__ + "static/media/2493.c65676c7.png";